<div class="bilan-rse-container">
	<div class="bilan-header">
		<h2>Notre Bilan RSE</h2>
		<a [href]="pdfUrl" target="_blank" download class="p-button p-button-text p-button-sm">
			<i class="pi pi-download mr-1"></i> Télécharger
		</a>
	</div>
	<app-flipbook [pdfUrl]="pdfUrl" [name]="''"></app-flipbook>
</div>
